module.exports = __webpack_public_path__ + "img/Minatochara.ca19c57c.png";